import { useEffect, useState, useCallback } from 'react';

export const useChunkedProducts = (initialItems = [], chunkSize = 12, isReadyToQueue = false) => {
  const [itemsQueued, setItemsQueued] = useState(null);
  const [itemsRequested, setItemsRequested] = useState(0);

  const pop = useCallback(() => {
    if (!itemsQueued?.length || itemsQueued.length === 0) {
      return [];
    }

    const itemsToTake = Math.min(chunkSize, itemsQueued.length);
    const newItems = [...itemsQueued];
    const chunk = newItems.splice(0, itemsToTake);

    setItemsQueued(newItems);
    setItemsRequested((prevCount) => prevCount + itemsToTake);
    return chunk;
  }, [itemsQueued, chunkSize]);

  useEffect(() => {
    if (isReadyToQueue && itemsRequested <= 0) {
      const itemsLength = initialItems?.length || 0;
      if (itemsLength > 0) {
        const queue = initialItems.map((product) => product.itemId);
        setItemsQueued(queue);
        setItemsRequested(0);
      } else if (!itemsQueued) {
        setItemsQueued([]);
      }
    }
  }, [isReadyToQueue]);

  return {
    pop,
    itemsQueued,
    itemsRequested
  };
};
